// this file does not require translation
// @utilities
const {
    PROC_REFER_A_FRIEND,
    recordLink,
    recordPath,
    recordProcess
} = require('utilities/tagging');
const SECTION_NAME = 'invita a un amigo';
const PAGE_NAMES = {
    CODE_SENDING_WITH_MAIL: 'envio codigo con mail',
    CODE_SENDING_WITHOUT_MAIL: 'envio codigo sin mail',
    PROMOTIONS: 'promociones',
    REFERRALS: 'referidos'
};
const BUTTON_TAGS = {
    REFER: 'referir',
};

const tagReferralsLink = (eventCategory, eventName) => {
    recordLink(`${SECTION_NAME} - ${eventCategory}`, eventName);
};

const tagReferralsPage = (pageName) => {
    recordPath(`${SECTION_NAME} - ${pageName}`);
};

const tagReferralsProc = (step, promoName) => {
    recordProcess(
        PROC_REFER_A_FRIEND,
        step,
        {
            eventCategory: SECTION_NAME,
            eventTag: promoName
        }
    );
};

module.exports = {
    BUTTON_TAGS,
    PAGE_NAMES,
    SECTION_NAME,
    tagReferralsLink,
    tagReferralsPage,
    tagReferralsProc
};